module.exports = __webpack_public_path__ + "img/symbol_10.d404e956.png";